import React from "react";
import { Link } from "react-router-dom";
import { AppBar, Toolbar, Typography, Button } from "@mui/material";

const pages = ["Home ", "About ", ];
const links = ["/", "/about", "/contact"];

function Header() {
  function BrandFont() {
    const brandFont = {
      fontFamily: "Solitreo, cursive",
      // fontSize: "2.5em",
    };
    return brandFont;
  }
  return (
    <AppBar
      position="relative"
      sx={{ marginBottom: "10px", backgroundColor: "white", marginTop: "10px" }}
      //remove shadow from appbar
      elevation={0}
    >
      <Toolbar>
        <Typography
          variant="h3"
          component="div"
          sx={{
            marginX: "5%",
            marginY: "0.5%",
            flexGrow: 4,
            color: "black",
            ...BrandFont(),
          }}
        >
          Aniq Aqil
        </Typography>
        <div sx={{ flexGrow: 1, marginRight: "5%" }}>
          {pages.map((page, index) => (
            <Button
              key={index}
              color="inherit"
              component={Link}
              to={links[index]}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{ color: "black", ...BrandFont() }}
              >
                {page}
              </Typography>
            </Button>
          ))}
        </div>
      </Toolbar>
    </AppBar>
  );
}
export default Header;
